/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService
 */

export const BadFrontendLocaleTypename = 'com.hubspot.scopegaps.models.BadFrontendLocale';
export const BadLocaleLanguageTypename = 'com.hubspot.scopegaps.models.BadLocaleLanguage';
export const ConflictingLocalesTypename = 'com.hubspot.scopegaps.models.ConflictingLocales';
export const MissingPortalContextTypename = 'com.hubspot.scopegaps.models.MissingPortalContext';
export const PortalNotFoundTypename = 'com.hubspot.scopegaps.models.PortalNotFound';
export const ScopeGroupNotFoundTypename = 'com.hubspot.scopegaps.models.ScopeGroupNotFound';
export const ScopeMissingEnumTypename = 'com.hubspot.scopegaps.models.ScopeMissingEnum';
export const ScopeNotFoundTypename = 'com.hubspot.scopegaps.models.ScopeNotFound';
export const FreeProductPieceTypename = 'com.hubspot.scopegaps.models.pieces.FreeProductPiece';
export const SkuProductPieceTypename = 'com.hubspot.scopegaps.models.pieces.SkuProductPiece';
export const getProductHierarchyRpc = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getProductHierarchy',
  auth: 'app',
  fingerprint: 'KFJyfm2wv1_a3HNHDiQX0NOYWRtcXq_X',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSatisfyingOptionsRpc = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getSatisfyingOptions',
  auth: 'app',
  fingerprint: 'aAvUtM_cLA2l4uY41cZtptOYWRtcXq_X',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSatisfyingCombosRpc = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getSatisfyingCombos',
  auth: 'app',
  fingerprint: 'aAvUtM_cLA3BkG6MxGG6wdOYWRtcXq_X',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};